import { render } from "./Productos.vue?vue&type=template&id=74bf06bd&scoped=true"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"

import "./Productos.vue?vue&type=style&index=0&id=74bf06bd&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bf06bd"]])

export default __exports__